import Markdown, { Components } from 'react-markdown';

type MarkdownRendererProps = {
  children?: string | null | undefined;
  className?: string;
};

const markdownComponents: Components = {
  strong: ({ node: _, ...props }) => <strong className="font-bold" {...props} />,
  em: ({ node: _, ...props }) => <em className="italic" {...props} />,
  ul: ({ node: _, ...props }) => <ul className="my-3 list-inside list-disc" {...props} />,
  ol: ({ node: _, ...props }) => <ol className="my-3 list-inside list-decimal" {...props} />,
  li: ({ node: _, ...props }) => <li className="mb-1" {...props} />,
  p: ({ node: _, ...props }) => <p className="mb-4 min-h-6" {...props} />,
  h1: ({ node: _, ...props }) => (
    <h1 className="mb-4 px-0 text-3xl font-bold lg:text-6xl" {...props} />
  ),
  h2: ({ node: _, ...props }) => (
    <h2 className="mb-4 px-0 text-2xl font-bold lg:text-4xl" {...props} />
  ),
  h3: ({ node: _, ...props }) => <h3 className="mb-4 text-xl font-bold lg:text-3xl" {...props} />,
  blockquote: ({ node: _, ...props }) => (
    <blockquote className="mb-4 border-l-4 border-gray-200 pl-4" {...props} />
  ),
  a: ({ node: _, ...props }) => {
    const href = props.href ?? '';
    const isExternal = /^https?:\/\//i.test(href);
    return (
      <a
        className="underline"
        {...props}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        target={isExternal ? '_blank' : undefined}
      />
    );
  },
};

export default function MarkdownRenderer({ children, className }: MarkdownRendererProps) {
  if (!children) {
    return null;
  }

  return (
    <div className={className}>
      <Markdown components={markdownComponents}>{children}</Markdown>
    </div>
  );
}
